import {
  Button,
  Table,
} from 'arag-ui-lib';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { TERTIARY, RIGHT } from '../../../helpers/constants';
import NewCommissionModal from './newCommissionModal';
import { formatSolicitorTableLabel } from '../../../helpers/functions';

const StagedStep1 = (props) => {
    const {
        toggleCommissionModal,
        commissionModal,
        lawsysFirms,
        onSuggestionSelected,
        onSuggestionChange,
        addCommission,
        removeSolicitor,
        agentsList,
    } = props;

    const commissionAgents = agentsList.length > 0 ? agentsList : [];
    const columns = [
        {
            propertyName: 'name',
            header: CONTENT_STRINGS.AGENT,
            id: 'name',
            formatter: (row) => formatSolicitorTableLabel({ label: row.name, aragProvider: row.aragProvider }),
        }
    ];
    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <Button
                    variant={TERTIARY}
                    arrowDirection={RIGHT}
                    label={CONTENT_STRINGS.ADD_NEW_COMMISSION}
                    onClick={toggleCommissionModal}
                    buttonTestId={'edit-staged-application-premium-setting-commissions-add-new-commission'}
                />
                <Table 
                    columns={columns} 
                    data={commissionAgents}
                    hasActions
                    actions={[{
                        key: 'removeAgent',
                        label: CONTENT_STRINGS.REMOVE,
                        callback: (row) => removeSolicitor(row.id),
                        actionTitle: CONTENT_STRINGS.ACTIONS,
                    }]}
                    tableWrapperTestId={'edit-staged-application-premium-setting-commissions-commissions'}
                />
            </div>
            {
                toggleCommissionModal
                ?
                    <NewCommissionModal
                        isOpen={commissionModal}
                        onSuggestionChange={onSuggestionChange}
                        onSuggestionSelected={onSuggestionSelected}
                        submitHandler={addCommission}
                        solicitorsList={agentsList}
                        lawsysFirms={lawsysFirms}
                        onClose={toggleCommissionModal}
                        modalTestId={'edit-staged-application-premium-setting-commissions-new-commission-modal'}
                        formGroupLabelTestId={'edit-staged-application-premium-setting-commissions-new-commission-modal-agent-text'}
                        formGroupInputTestId={'edit-staged-application-premium-setting-commissions-new-commission-modal-agent-select'}
                        buttonTestId={'edit-staged-application-premium-setting-commissions-new-commission-modal-add'}
                        linkTestId={'edit-staged-application-premium-setting-commissions-new-commission-modal-cancel'}
                    />
                :
                    null
            }
        </>
    );
};
export default StagedStep1;
